import "./GiftModal.css";
import { X, Gift } from "lucide-react";


export default function GiftModal({
    gifts = [],
    selectedGift,
    setSelectedGift,
    onClose,
    onConfirm
}) {


    return (

        <div className="gift-overlay">


            <div className="gift-modal">


                <button
                    className="close-btn"
                    onClick={onClose}
                >
                    <X size={20} />
                </button>



                <div className="gift-title">

                    <Gift size={24} />

                    <p>
                        انتخاب هدیه
                    </p>

                </div>



                <div className="gift-list">


                    {
                        gifts.map(gift => (


                            <div

                                key={gift.id}

                                className={
                                    selectedGift?.id === gift.id
                                        ?
                                        "gift-item active"
                                        :
                                        "gift-item"
                                }


                                onClick={() =>
                                    setSelectedGift(gift)
                                }

                            >

                                <span>
                                    {gift.name}
                                </span>


                            </div>


                        ))
                    }


                </div>



                <button

                    className="confirm-gift"

                    disabled={!selectedGift}

                    onClick={onConfirm}

                >

                    تایید هدیه

                </button>


            </div>


        </div>

    );

}